import { render, staticRenderFns } from "./journey-template-widget.vue?vue&type=template&id=58bb4ee4&"
import script from "./journey-template-widget.vue?vue&type=script&lang=js&"
export * from "./journey-template-widget.vue?vue&type=script&lang=js&"
import style0 from "./journey-template-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports